var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    "data-name": "Laag 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 243.71 284.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #FFFFFF;\r\n      }\r\n\r\n      .cls-1 {\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "42workspace") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M551.75,1450.15v-29.88c1.29-.22,2.57-.34,3.78-.67a14.66,14.66,0,1,0-18.43-15.1c0,.6-.12,1-.86,1q-14.38,0-28.79,0a2.55,2.55,0,0,1-.38-.12,41.22,41.22,0,0,1,3-16.14,43.69,43.69,0,0,1,17.37-21.27,44.71,44.71,0,1,1,24.32,82.24Z",
    transform: "translate(-352.76 -1360.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M596.36,1496.77H507.11v-27.92h89.25Z",
    transform: "translate(-352.76 -1360.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.76,1496.74H488.52V1361Zm107.75-28H420.75l39.76-39.76Z",
    transform: "translate(-352.76 -1360.7)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M408.24,1590.41l-6.69-24.94-6.81,24.94h-9.48l-11.8-36.07h9.79l7.06,26.53,6.91-26.53h9l7.06,26.53,7-26.53h9.38l-11.91,36.07Z",
    transform: "translate(-352.76 -1360.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M457.56,1576.49c0,8.56-6.08,14.23-15.15,14.23s-15.2-5.67-15.2-14.23,6.08-14.17,15.2-14.17S457.56,1567.94,457.56,1576.49Zm-21.38.11c0,4.33,2.52,7.21,6.23,7.21s6.18-2.88,6.18-7.21-2.52-7.22-6.18-7.22S436.18,1572.32,436.18,1576.6Z",
    transform: "translate(-352.76 -1360.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M471.27,1567.32a10.15,10.15,0,0,1,9-5.1v8c-5.16-.46-8.56,2-9,5.87v14.28h-8.92v-27.78h8.92Z",
    transform: "translate(-352.76 -1360.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M493.53,1582.83v7.58h-8.91v-38.24h8.91v20.2l9.17-9.74h10.1l-10.2,10.67,10.51,17.11H502.55l-6-10.72Z",
    transform: "translate(-352.76 -1360.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M405.2,1602.94l-3.45,7.17c-3.81-2.22-8.6-3.77-11.54-3.77-2.37,0-4,.88-4,2.63,0,6.24,19.07,2.68,19.07,15.72,0,7.21-6.39,11-14.43,11a26.93,26.93,0,0,1-16.49-5.77l3.56-7.06c3.71,3.24,9.27,5.41,13,5.41,2.89,0,4.69-1.09,4.69-3.15,0-6.39-19.06-2.57-19.06-15.35,0-6.65,5.72-10.88,14.37-10.88A27.07,27.07,0,0,1,405.2,1602.94Z",
    transform: "translate(-352.76 -1360.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M440.76,1621.65c0,8.45-5.05,14.07-12.83,14.07a10.29,10.29,0,0,1-8.5-4v13.7h-8.92v-37.77h8.92v3.66a10.13,10.13,0,0,1,8.29-4C435.56,1607.32,440.76,1613,440.76,1621.65Zm-9-.26c0-4.22-2.52-7.21-6.23-7.21s-6.13,3-6.13,7.21,2.52,7.27,6.13,7.27S431.79,1625.67,431.79,1621.39Z",
    transform: "translate(-352.76 -1360.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M470.13,1617.27v18.14h-8.7v-3.2c-1.81,2.37-4.75,3.61-8.51,3.61-5.92,0-9.53-3.61-9.53-8.71s3.76-8.35,10.67-8.4h7.31v-.41c0-2.73-1.8-4.38-5.41-4.38a19.4,19.4,0,0,0-8.29,2.32l-2.53-5.88a29.32,29.32,0,0,1,12.88-3.14C465.65,1607.22,470.08,1611,470.13,1617.27Zm-8.76,8.71v-2.48h-5.61c-2.68,0-4,.93-4,3s1.44,3.3,3.91,3.3C458.44,1629.79,460.81,1628.25,461.37,1626Z",
    transform: "translate(-352.76 -1360.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M501,1613.56l-6.39,3.86a6.67,6.67,0,0,0-5.62-2.88c-3.45,0-5.82,2.83-5.82,7s2.37,7.06,5.82,7.06a6.06,6.06,0,0,0,5.67-3.15l6.49,3.82c-2.26,4.07-6.75,6.44-12.62,6.44-8.56,0-14.33-5.67-14.33-14.12s5.83-14.28,14.43-14.28C494.1,1607.32,498.53,1609.59,501,1613.56Z",
    transform: "translate(-352.76 -1360.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M530.84,1623.92H511.31a6.42,6.42,0,0,0,6.54,5.15,9.42,9.42,0,0,0,6.65-2.83l4.69,4.58a16,16,0,0,1-12.11,4.9c-9.07,0-14.74-5.67-14.74-14.12,0-8.61,5.88-14.28,14.48-14.28C526.61,1607.32,531.46,1613.76,530.84,1623.92Zm-8.56-4.8c0-3.4-2.16-5.61-5.36-5.61s-5.2,2.26-5.77,5.61Z",
    transform: "translate(-352.76 -1360.7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.c584e559c0ed36aa903b249437de0e3d.svg";
export { ForwardRef as ReactComponent };